var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 15V17.5C18.75 18.1894 18.1894 18.75 17.5 18.75H2.5C1.81062 18.75 1.25 18.1894 1.25 17.5V15C1.25 14.655 1.53 14.375 1.875 14.375C2.22 14.375 2.5 14.655 2.5 15V17.5H17.5V15C17.5 14.655 17.78 14.375 18.125 14.375C18.47 14.375 18.75 14.655 18.75 15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1831 10.4419C4.93872 10.1975 4.93872 9.8025 5.1831 9.55813C5.42747 9.31375 5.82247 9.31375 6.06685 9.55813L9.37497 12.8663V1.875C9.37497 1.53 9.65497 1.25 9.99997 1.25C10.345 1.25 10.625 1.53 10.625 1.875V12.8663L13.9331 9.55813C14.1775 9.31375 14.5725 9.31375 14.8168 9.55813C15.0612 9.8025 15.0612 10.1975 14.8168 10.4419L10.4418 14.8169C10.1943 15.065 9.79747 15.0569 9.55747 14.8169L5.1831 10.4419Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSave);
export default __webpack_public_path__ + "static/media/icon-save.f1db2aaebc13e6892a3387635b75d16f.svg";
export { ForwardRef as ReactComponent };